(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8416],{

/***/ 50669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLocationBlueCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#DBEFFF"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.348 15.2A6.4 6.4 0 0016.8 9.652V8h-1.6v1.652A6.4 6.4 0 009.652 15.2H8v1.6h1.652a6.4 6.4 0 005.548 5.548V24h1.6v-1.652a6.4 6.4 0 005.548-5.548H24v-1.6h-1.652zM16 20.8a4.8 4.8 0 110-9.6 4.8 4.8 0 010 9.6zm2.8-4.8a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLocationBlueCircle);

/***/ }),

/***/ 90831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLocationPinOutlined(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#location-pin-outlined_svg__clip0_239_7772)",
    fill: "#fff"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 1.25A4.24 4.24 0 005 0C3.875 0 2.8.45 2 1.25c-.8.8-1.25 1.85-1.25 3 0 2.275 2.175 4.175 3.35 5.2.15.15.3.275.425.375.15.125.325.2.5.2s.35-.075.5-.2c.1-.1.25-.225.425-.375 1.125-1.025 3.3-2.925 3.3-5.225C9.25 3.1 8.8 2.05 8 1.25zM5.525 9c-.175.15-.3.275-.425.375-.05.05-.15.05-.2 0-.125-.1-.25-.225-.425-.375-1.1-.975-3.125-2.75-3.125-4.775 0-2 1.65-3.65 3.65-3.65a3.638 3.638 0 013.65 3.65c0 2.025-2.025 3.8-3.125 4.775z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.125 2.25C4.1 2.25 3.25 3.1 3.25 4.125S4.1 6 5.125 6 7 5.15 7 4.125 6.15 2.25 5.125 2.25zm0 3.15A1.28 1.28 0 013.85 4.125c0-.7.575-1.275 1.275-1.275S6.4 3.425 6.4 4.125 5.825 5.4 5.125 5.4z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "location-pin-outlined_svg__clip0_239_7772"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLocationPinOutlined);

/***/ }),

/***/ 91218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AsyncSelect$1; }
});

// UNUSED EXPORTS: useAsync

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/Select-ef7c0426.esm.js + 3 modules
var Select_ef7c0426_esm = __webpack_require__(71021);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/useStateManager-7e1e8489.esm.js
var useStateManager_7e1e8489_esm = __webpack_require__(88137);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(33028);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-641ee5b8.esm.js + 3 modules
var index_641ee5b8_esm = __webpack_require__(99438);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/useAsync-c64f5536.esm.js







var _excluded = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function useAsync(_ref) {
  var _ref$defaultOptions = _ref.defaultOptions,
    propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions,
    _ref$cacheOptions = _ref.cacheOptions,
    cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions,
    propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading,
    propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    propsOnInputChange = _ref.onInputChange,
    _ref$filterOption = _ref.filterOption,
    filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption,
    restSelectProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var propsInputValue = restSelectProps.inputValue;
  var lastRequest = (0,react.useRef)(undefined);
  var mounted = (0,react.useRef)(false);
  var _useState = (0,react.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    defaultOptions = _useState2[0],
    setDefaultOptions = _useState2[1];
  var _useState3 = (0,react.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    stateInputValue = _useState4[0],
    setStateInputValue = _useState4[1];
  var _useState5 = (0,react.useState)(propsDefaultOptions === true),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = (0,react.useState)(undefined),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    loadedInputValue = _useState8[0],
    setLoadedInputValue = _useState8[1];
  var _useState9 = (0,react.useState)([]),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    loadedOptions = _useState10[0],
    setLoadedOptions = _useState10[1];
  var _useState11 = (0,react.useState)(false),
    _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
    passEmptyOptions = _useState12[0],
    setPassEmptyOptions = _useState12[1];
  var _useState13 = (0,react.useState)({}),
    _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
    optionsCache = _useState14[0],
    setOptionsCache = _useState14[1];
  var _useState15 = (0,react.useState)(undefined),
    _useState16 = (0,slicedToArray/* default */.Z)(_useState15, 2),
    prevDefaultOptions = _useState16[0],
    setPrevDefaultOptions = _useState16[1];
  var _useState17 = (0,react.useState)(undefined),
    _useState18 = (0,slicedToArray/* default */.Z)(_useState17, 2),
    prevCacheOptions = _useState18[0],
    setPrevCacheOptions = _useState18[1];
  if (cacheOptions !== prevCacheOptions) {
    setOptionsCache({});
    setPrevCacheOptions(cacheOptions);
  }
  if (propsDefaultOptions !== prevDefaultOptions) {
    setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    setPrevDefaultOptions(propsDefaultOptions);
  }
  (0,react.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  var loadOptions = (0,react.useCallback)(function (inputValue, callback) {
    if (!propsLoadOptions) return callback();
    var loader = propsLoadOptions(inputValue, callback);
    if (loader && typeof loader.then === 'function') {
      loader.then(callback, function () {
        return callback();
      });
    }
  }, [propsLoadOptions]);
  (0,react.useEffect)(function () {
    if (propsDefaultOptions === true) {
      loadOptions(stateInputValue, function (options) {
        if (!mounted.current) return;
        setDefaultOptions(options || []);
        setIsLoading(!!lastRequest.current);
      });
    }
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onInputChange = (0,react.useCallback)(function (newValue, actionMeta) {
    var inputValue = (0,index_641ee5b8_esm.L)(newValue, actionMeta, propsOnInputChange);
    if (!inputValue) {
      lastRequest.current = undefined;
      setStateInputValue('');
      setLoadedInputValue('');
      setLoadedOptions([]);
      setIsLoading(false);
      setPassEmptyOptions(false);
      return;
    }
    if (cacheOptions && optionsCache[inputValue]) {
      setStateInputValue(inputValue);
      setLoadedInputValue(inputValue);
      setLoadedOptions(optionsCache[inputValue]);
      setIsLoading(false);
      setPassEmptyOptions(false);
    } else {
      var request = lastRequest.current = {};
      setStateInputValue(inputValue);
      setIsLoading(true);
      setPassEmptyOptions(!loadedInputValue);
      loadOptions(inputValue, function (options) {
        if (!mounted) return;
        if (request !== lastRequest.current) return;
        lastRequest.current = undefined;
        setIsLoading(false);
        setLoadedInputValue(inputValue);
        setLoadedOptions(options || []);
        setPassEmptyOptions(false);
        setOptionsCache(options ? (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, optionsCache), {}, (0,defineProperty/* default */.Z)({}, inputValue, options)) : optionsCache);
      });
    }
  }, [cacheOptions, loadOptions, loadedInputValue, optionsCache, propsOnInputChange]);
  var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restSelectProps), {}, {
    options: options,
    isLoading: isLoading || propsIsLoading,
    onInputChange: onInputChange,
    filterOption: filterOption
  });
}



// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
var use_isomorphic_layout_effect_browser_esm = __webpack_require__(84337);
;// CONCATENATED MODULE: ../../node_modules/react-select/async/dist/react-select-async.esm.js

























var AsyncSelect = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var stateManagedProps = useAsync(props);
  var selectProps = (0,useStateManager_7e1e8489_esm.u)(stateManagedProps);
  return /*#__PURE__*/react.createElement(Select_ef7c0426_esm.S, (0,esm_extends/* default */.Z)({
    ref: ref
  }, selectProps));
});
var AsyncSelect$1 = AsyncSelect;




/***/ }),

/***/ 18831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ StyledCompactSelectWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);




const StyledCompactSelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div `
    font-size: 14px;
    height: 46px;

    .select-container {
        height: 100%;
    }

    .select-control {
        font-size: 12px;
        height: 100%;
        outline: none;
        box-shadow: none;
        border: 1px solid rgba(35, 85, 252, 0.12);
        border-radius: 14px;
        background: #f9fafb;
        padding: 0 13px 0 12px;
        min-height: 46px;

        &:hover {
            border-color: rgba(35, 85, 252, 0.24);
            background: #ffffff;
        }
    }

    .select-value-container {
        padding: 0;
        overflow: hidden;
        height: 100%;
    }

    .select-singleValue {
        margin-left: 0;
        color: #0a0f1e;
        font-size: 14px;
        line-height: 20px;
    }

    .select-option {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};

        &:hover {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.selected,
        &.focused {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.disabled {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_600 */ .Z.GREY_600};
            cursor: not-allowed;
        }
    }

    .select-input {
        input {
            caret-color: transparent;
        }
    }

    .select-control--searchable .select-input {
        color: #0a0f1e;
        cursor: text;

        input {
            caret-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
            color: inherit;
            cursor: text;
            font-size: 16px;
            opacity: 1 !important;
        }
    }

    .select-placeholder {
        color: #5a6480;
        font-family: ${_constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REGULAR */ .Z.REGULAR};
        font-size: 14px;
        line-height: 20px;
    }

    .select-dropDownIndicator {
        svg {
            width: 18px;
            height: 18px;
            transform: rotate(90deg);
        }
    }

    .select-customDropDownIndicator {
        padding: 0;
    }

    .select-noOptionMessage {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
    }

    .select-customDropDownIndicator,
    .select-clear {
        cursor: pointer;
    }
`;


//# sourceMappingURL=CompactSelect.styles.js.map


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CompactControlComponent; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99438);




const CompactControlComponent = (_a) => {
    var { children, className } = _a, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["children", "className"]);
    const { selectProps } = props;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_2__.c.Control, Object.assign({}, props, { className: [
            className,
            "select-control",
            selectProps.isSearchable ? "select-control--searchable" : null,
        ]
            .filter(Boolean)
            .join(" ") }, { children: children })));
};


//# sourceMappingURL=RCompactSelectDerived.js.map


/***/ }),

/***/ 92036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Search; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_select_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91218);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80594);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53796);
/* harmony import */ var _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11350);
/* harmony import */ var _layout_Flex_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31013);
/* harmony import */ var _Select_Select_styles_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82836);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94897);











const Search = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref) => {
    var _a;
    const { id = props === null || props === void 0 ? void 0 : props.name, label, errorMsg, option, required, noOptionText, noOptionHandler, labelFormatter, isClearable = false, value = null, outline, customDropDownIcon, customSeparatorIndicator, debounceDuration = 500, loadOptions, menuPosition = "fixed", borderRadius, size = "md" } = props, restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_9__/* .__rest */ ._)(props, ["id", "label", "errorMsg", "option", "required", "noOptionText", "noOptionHandler", "labelFormatter", "isClearable", "value", "outline", "customDropDownIcon", "customSeparatorIndicator", "debounceDuration", "loadOptions", "menuPosition", "borderRadius", "size"]);
    const debouncedFetchData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()((query, cb) => {
        loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions(query, cb);
    }, debounceDuration), []);
    const CustomDropdown = (props) => {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .DropdownIndicatorComponentWrapper */ .uy, Object.assign({}, props, { children: customDropDownIcon })));
    };
    const MainChild = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select_async__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({}, restProps, { ref: ref, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, options: option, loadOptions: debouncedFetchData, components: Object.assign({ DropdownIndicator: CustomDropdown !== null && CustomDropdown !== void 0 ? CustomDropdown : _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .DropdownIndicatorComponent */ .fz, SelectContainer: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .ContainerComponent */ .e$, Control: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .ControlComponent */ .Fr, SingleValue: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .SingleValueComponent */ .G$, NoOptionsMessage: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .NoOptionsMessageComponent */ .c1, Option: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .OptionComponent */ .x8, Input: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .InputComponent */ .am, IndicatorSeparator: (_a = customSeparatorIndicator) !== null && _a !== void 0 ? _a : null, ValueContainer: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .ValueComponent */ .u$, Placeholder: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .PlaceholderComponent */ .WB, ClearIndicator: _Select_RSelectDerived_js__WEBPACK_IMPORTED_MODULE_5__/* .ClearIconComponent */ .OD }, props === null || props === void 0 ? void 0 : props.components), noOptionsMessage: noOptionHandler !== null && noOptionHandler !== void 0 ? noOptionHandler : (() => noOptionText !== null && noOptionText !== void 0 ? noOptionText : null), formatOptionLabel: labelFormatter, isClearable: isClearable, value: value, menuPosition: menuPosition })) }));
    const BaseStyled = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Flex_js__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, Object.assign({ flexDirection: "column", gap: 12 }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, Object.assign({ as: "label", color: _constants_colors_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GREY_900 */ .Z.GREY_900, required: required }, { children: label })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select_styles_js__WEBPACK_IMPORTED_MODULE_7__/* .StyledSelectWrapper */ .W, Object.assign({ outline: outline, size: size }, { children: MainChild })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, Object.assign({ color: _constants_colors_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].RED */ .Z.RED, size: "s" }, { children: errorMsg }))] })));
    return (props === null || props === void 0 ? void 0 : props.components) ? MainChild : BaseStyled;
});


//# sourceMappingURL=Search.js.map


/***/ }),

/***/ 82836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ StyledSelectWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82740);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);
/* harmony import */ var _constants_theme_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63298);
/* harmony import */ var _constants_files_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65357);
/* harmony import */ var _constants_color_variant_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60603);
/* harmony import */ var _constants_zIndexList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94069);
/* harmony import */ var _constants_ui_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10193);
/* harmony import */ var _mixins_style_mixins_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13261);
/* harmony import */ var _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47755);
/* harmony import */ var _mixins_cursor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27106);
/* harmony import */ var _mixins_font_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79047);













const StyledSelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div */ .ZP.div `
    ${(props) => {
    const size = props === null || props === void 0 ? void 0 : props.size;
    switch (size) {
        case "sm":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                    height: ${_constants_ui_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonElementSizeMap */ .K[size]};
                    &,
                    .select-value-container [data-select-value-label] {
                        ${(0,_mixins_font_js__WEBPACK_IMPORTED_MODULE_10__/* .getCommonFontStyleMixin */ .d)({ size })};
                    }
                `;
        default:
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                    font-size: 16px;
                    height: 48px;
                `;
    }
}};

    .select-container {
        height: 100%;
    }
    .select-control {
        font-size: 12px;
        height: 100%;
        outline: none;
        padding: 0 16px;
        box-shadow: none;

        ${({ outline }) => {
    switch (outline) {
        case "border":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                        border: 1px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
                    `;
        case "underline":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                        border: none;
                        border-radius: 0;
                        border-bottom: 2px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
                    `;
        default:
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv ``;
    }
}}

        ${({ borderRadius }) => borderRadius
    ? styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                      border-radius: ${borderRadius}px;
                  `
    : ""}

        &:hover {
            border-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }
    }

    .select-value-container {
        padding: 0;
        overflow: hidden;
        height: 100%;
    }

    .select-singleValue {
        margin-left: 5px;
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};
    }

    .select-option {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};

        &:hover {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.selected,
        &.focused {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.disabled {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_600 */ .Z.GREY_600};
            cursor: not-allowed;
        }
    }

    .select-input {
        input {
            caret-color: transparent;
        }
    }

    .select-control--searchable .select-input {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};
        cursor: text;

        input {
            caret-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
            color: inherit;
            cursor: text;
            font-size: 16px;
            opacity: 1 !important;
        }
    }

    .select-placeholder {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_400 */ .Z.GREY_400};
        font-family: ${_constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REGULAR */ .Z.REGULAR};
        font-size: 13px;
    }

    .select-dropDownIndicator {
        svg {
            width: 18px;
            height: 18px;
            transform: rotate(90deg);
        }
    }
    .select-customDropDownIndicator {
        padding: 0;
    }

    .select-noOptionMessage {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
    }

    .select-multiValue {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_300 */ .Z.GREY_300};
        border: 2px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RED */ .Z.RED};
        padding: 2px;
    }

    .select-customDropDownIndicator,
    .select-clear {
        cursor: pointer;
    }
`;


//# sourceMappingURL=Select.styles.js.map


/***/ }),

/***/ 81720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_icons_location_blue_circle_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50669);
/* harmony import */ var _CurrentLocation_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87163);
/* harmony import */ var _CurrentLocation_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_CurrentLocation_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26513);





var CurrentLocation = function(param) {
    var onClick = param.onClick, id = param.id, _showLabel = param.showLabel, showLabel = _showLabel === void 0 ? true : _showLabel;
    var isMobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var handleEvents = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_CurrentLocation_module_scss__WEBPACK_IMPORTED_MODULE_4___default().main),
        onTouchEnd: handleEvents,
        onMouseDown: handleEvents,
        id: id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_location_blue_circle_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            !isMobileScreen && showLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CurrentLocation_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                id: "".concat(id, "__text"),
                children: "Get Current Location"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurrentLocation);


/***/ }),

/***/ 68416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fields_QuoteFormLocationField; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react-select/async/dist/react-select-async.esm.js + 1 modules
var react_select_async_esm = __webpack_require__(91218);
// EXTERNAL MODULE: ../../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(80594);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ../core-ui/dist/components/CompactSelect/CompactSelect.styles.js
var CompactSelect_styles = __webpack_require__(18831);
// EXTERNAL MODULE: ../core-ui/dist/components/CompactSelect/RCompactSelectDerived.js
var RCompactSelectDerived = __webpack_require__(85666);
// EXTERNAL MODULE: ../core-ui/dist/components/Select/RSelectDerived.js + 1 modules
var RSelectDerived = __webpack_require__(11350);
;// CONCATENATED MODULE: ../core-ui/dist/components/CompactSearch/CompactSearch.js









const CompactSearch = react.forwardRef((props, ref) => {
    var _a;
    const { id = props === null || props === void 0 ? void 0 : props.name, option = [], noOptionText, noOptionHandler, labelFormatter, isClearable = false, value = null, customDropDownIcon, customSeparatorIndicator, debounceDuration = 500, loadOptions, menuPosition = "absolute" } = props, restProps = (0,_tslib/* __rest */._)(props, ["id", "option", "noOptionText", "noOptionHandler", "labelFormatter", "isClearable", "value", "customDropDownIcon", "customSeparatorIndicator", "debounceDuration", "loadOptions", "menuPosition"]);
    const debouncedFetchData = (0,react.useCallback)(lodash_debounce_default()((query, cb) => {
        loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions(query, cb);
    }, debounceDuration), []);
    const CustomDropdown = (dropdownProps) => ((0,jsx_runtime.jsx)(RSelectDerived/* DropdownIndicatorComponentWrapper */.uy, Object.assign({}, dropdownProps, { children: customDropDownIcon })));
    return ((0,jsx_runtime.jsx)(CompactSelect_styles/* StyledCompactSelectWrapper */.U, { children: (0,jsx_runtime.jsx)(react_select_async_esm/* default */.Z, Object.assign({}, restProps, { ref: ref, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, options: option, loadOptions: debouncedFetchData, components: Object.assign({ DropdownIndicator: customDropDownIcon != null
                    ? CustomDropdown
                    : RSelectDerived/* DropdownIndicatorComponent */.fz, SelectContainer: RSelectDerived/* ContainerComponent */.e$, Control: RCompactSelectDerived/* CompactControlComponent */._, SingleValue: RSelectDerived/* SingleValueComponent */.G$, NoOptionsMessage: RSelectDerived/* NoOptionsMessageComponent */.c1, Option: RSelectDerived/* OptionComponent */.x8, Input: RSelectDerived/* InputComponent */.am, IndicatorSeparator: (_a = customSeparatorIndicator) !== null && _a !== void 0 ? _a : null, ValueContainer: RSelectDerived/* ValueComponent */.u$, Placeholder: RSelectDerived/* PlaceholderComponent */.WB, ClearIndicator: RSelectDerived/* ClearIconComponent */.OD }, props === null || props === void 0 ? void 0 : props.components), noOptionsMessage: noOptionHandler !== null && noOptionHandler !== void 0 ? noOptionHandler : (() => noOptionText !== null && noOptionText !== void 0 ? noOptionText : null), formatOptionLabel: labelFormatter, isClearable: isClearable, value: value, menuPosition: menuPosition })) }));
});


//# sourceMappingURL=CompactSearch.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/CompactSearch/index.js


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core-ui/dist/methods/browser.js
var browser = __webpack_require__(82238);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useKeyboardAwareField.js
var useKeyboardAwareField = __webpack_require__(94344);
// EXTERNAL MODULE: ./components/homepage-v2/hooks/useHomepageV2Translation.ts
var useHomepageV2Translation = __webpack_require__(14394);
// EXTERNAL MODULE: ./components/homepage-v2/methods/homepageV2CompactSheet.ts
var homepageV2CompactSheet = __webpack_require__(14199);
// EXTERNAL MODULE: ./methods/location-search.ts
var location_search = __webpack_require__(75002);
// EXTERNAL MODULE: ./methods/uiUtil.ts
var uiUtil = __webpack_require__(34695);
// EXTERNAL MODULE: ./components/posting-form/common/current-location/UserCurrentLocation.tsx
var UserCurrentLocation = __webpack_require__(51035);
// EXTERNAL MODULE: ./components/homepage-v2/load-quote/quoteFormSelectParts.tsx
var quoteFormSelectParts = __webpack_require__(83165);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/QuoteFormFields.module.scss
var QuoteFormFields_module = __webpack_require__(62095);
var QuoteFormFields_module_default = /*#__PURE__*/__webpack_require__.n(QuoteFormFields_module);
;// CONCATENATED MODULE: ./components/homepage-v2/hero-section/quote-form-card/fields/QuoteFormLocationField.tsx
















var QuoteFormLocationField = function(param) {
    var id = param.id, name = param.name, placeholder = param.placeholder, icon = param.icon, value = param.value, onChange = param.onChange, locationSearchSource = param.locationSearchSource, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _inSheet = param.inSheet, inSheet = _inSheet === void 0 ? false : _inSheet, _fieldRole = param.fieldRole, fieldRole = _fieldRole === void 0 ? "pickup" : _fieldRole, messages = param.messages, onInputValueChange = param.onInputValueChange, _portalMenu = param.portalMenu, portalMenu = _portalMenu === void 0 ? false : _portalMenu, selectRef = param.selectRef;
    var fieldWrapRef = (0,react.useRef)(null);
    // Sheet fields mount on open. Defaulting the media query to `false` paints desktop
    // select config for a frame, then flips — that remount loses the first tap's focus.
    // Quote form is already on the page, so its query has settled before anyone taps.
    var isMobile = (0,useMediaQuery/* default */.Z)({
        queryType: "medium-screen",
        initialState: inSheet ? (0,browser/* isMobileViewport */.UM)() : false
    });
    var fieldConfig = (0,react.useMemo)(function() {
        var base = (0,homepageV2CompactSheet/* getQuoteFormLocationFieldConfig */.XQ)({
            inSheet: inSheet,
            role: fieldRole,
            isMobile: isMobile
        });
        if (!portalMenu) {
            return base;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
            portalMenu: true
        });
    }, [
        fieldRole,
        inSheet,
        isMobile,
        portalMenu
    ]);
    var menuConfig = (0,react.useMemo)(function() {
        return (0,quoteFormSelectParts/* getQuoteFormLocationMenuConfig */.Ml)(fieldConfig.portalMenu, inSheet);
    }, [
        fieldConfig.portalMenu,
        inSheet
    ]);
    var ref = (0,useKeyboardAwareField/* useKeyboardAwareField */.z)(fieldWrapRef, {
        enabled: fieldConfig.keyboardAware,
        // Route-step fields sit at the top of the sheet. Scrolling the overflow root
        // on focus dismisses the keyboard on some iOS / WebView builds.
        scrollOnFocus: !inSheet,
        menuMaxHeight: fieldConfig.maxMenuHeight,
        defaultMenuPlacement: fieldConfig.menuPlacement
    }), menuPlacement = ref.menuPlacement, onFieldFocus = ref.onFieldFocus, onFieldBlur = ref.onFieldBlur, syncPlacement = ref.syncPlacement;
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var copy = messages !== null && messages !== void 0 ? messages : {
        enterLocation: t("homepageV2:hero.quoteForm.enterLocation"),
        noSuchLocation: t("homepageV2:hero.quoteForm.noSuchLocation"),
        getMoreCharactersLabel: function(count) {
            return t("homepageV2:hero.quoteForm.moreCharacters", {
                count: count
            });
        }
    };
    var selectedOption = value ? (0,uiUtil/* generateSelectOption */.Ow)((0,UserCurrentLocation/* mapPlaceSearchResponseIntoText */.P)(value, 2), value, value.place_id) : undefined;
    var handleChange = function(option) {
        var selected = option;
        onChange(selected === null || selected === void 0 ? void 0 : selected.value);
    };
    var getNoOptionsMessage = (0,react.useCallback)(function(inputValue) {
        return (0,quoteFormSelectParts/* getQuoteFormLocationNoOptionsMessage */.W1)(inputValue, copy);
    }, [
        copy
    ]);
    var selectComponents = (0,react.useMemo)(function() {
        return (0,quoteFormSelectParts/* createQuoteFormLocationSelectComponents */._P)((QuoteFormFields_module_default()), {
            icon: icon,
            getNoOptionsMessage: getNoOptionsMessage,
            revealNativeInput: inSheet
        });
    }, [
        getNoOptionsMessage,
        icon,
        inSheet
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: fieldWrapRef,
        className: classnames_default()((QuoteFormFields_module_default()).fieldWrap, (QuoteFormFields_module_default()).fieldWrapSelect, (QuoteFormFields_module_default()).fieldWrapSearchable),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactSearch, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: selectRef,
            maxMenuHeight: fieldConfig.maxMenuHeight,
            id: id,
            name: name,
            option: [],
            value: selectedOption,
            placeholder: placeholder,
            isClearable: true,
            isDisabled: isDisabled,
            isSearchable: true,
            openMenuOnClick: false,
            customDropDownIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            menuPlacement: menuPlacement,
            menuShouldScrollIntoView: fieldConfig.menuShouldScrollIntoView,
            onFocus: onFieldFocus,
            onBlur: onFieldBlur,
            onMenuOpen: syncPlacement
        }, menuConfig), {
            loadOptions: function(str, cb) {
                return (0,location_search/* generateCityLoadOption */.EF)(str, cb, {
                    source: locationSearchSource
                });
            },
            onChange: handleChange,
            onInputChange: function(value) {
                if (value) {
                    syncPlacement();
                }
                onInputValueChange === null || onInputValueChange === void 0 ? void 0 : onInputValueChange(value);
            },
            noOptionHandler: function(o) {
                return getNoOptionsMessage(o.inputValue);
            },
            components: selectComponents
        }))
    });
};
/* harmony default export */ var fields_QuoteFormLocationField = (QuoteFormLocationField);


/***/ }),

/***/ 14394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useHomepageV2Translation */
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42386);

var HOMEPAGE_V2_NAMESPACES = [
    "homepageV2",
    "mktCardV2",
    "load-form",
    "navigation",
    "common"
];
var useHomepageV2Translation = function() {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)(HOMEPAGE_V2_NAMESPACES), t = ref.t, i18n = ref.i18n;
    return {
        t: t,
        i18n: i18n
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useHomepageV2Translation);


/***/ }),

/***/ 83165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EG": function() { return /* binding */ renderHighlightedText; },
/* harmony export */   "KP": function() { return /* binding */ createQuoteFormChevronIndicator; },
/* harmony export */   "MP": function() { return /* binding */ createQuoteFormLocationMenu; },
/* harmony export */   "Mf": function() { return /* binding */ createQuoteFormLocationPlaceholder; },
/* harmony export */   "Ml": function() { return /* binding */ getQuoteFormLocationMenuConfig; },
/* harmony export */   "UY": function() { return /* binding */ createQuoteFormNoOptionsMessage; },
/* harmony export */   "W1": function() { return /* binding */ getQuoteFormLocationNoOptionsMessage; },
/* harmony export */   "_P": function() { return /* binding */ createQuoteFormLocationSelectComponents; },
/* harmony export */   "aG": function() { return /* binding */ createQuoteFormLocationControl; },
/* harmony export */   "iV": function() { return /* binding */ createQuoteFormLocationInput; },
/* harmony export */   "jU": function() { return /* binding */ createQuoteFormLorryControl; },
/* harmony export */   "mL": function() { return /* binding */ createQuoteFormLocationSingleValue; },
/* harmony export */   "n": function() { return /* binding */ hiddenMultiValue; },
/* harmony export */   "pM": function() { return /* binding */ filterOptionByLabel; },
/* harmony export */   "pP": function() { return /* binding */ createQuoteFormMultiValueContainer; }
/* harmony export */ });
/* unused harmony export createQuoteFormLocationOption */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99438);
/* harmony import */ var _vahak_core_ui_dist_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73242);
/* harmony import */ var _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69849);
/* harmony import */ var _vahak_core_dist_standard_icons_location_pin_outlined_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90831);
/* harmony import */ var _placeLabels__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2451);
/* harmony import */ var _methods_location_search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75002);












/** react-select defaults options to display:block — row layout must be inline. */ var QUOTE_FORM_LOCATION_OPTION_ROW_STYLE = {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 10
};
var QUOTE_FORM_LOCATION_MENU_STYLES = {
    menuList: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base), {
            padding: 0
        });
    },
    option: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base, QUOTE_FORM_LOCATION_OPTION_ROW_STYLE);
    }
};
/** Compact sheet: make the native <input> the tap target (react-select autosizes it to ~2px). */ var SHEET_NATIVE_INPUT_STYLES = {
    input: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base), {
            width: "100%",
            gridTemplateColumns: "0 minmax(2px, 1fr)",
            opacity: 1,
            visibility: "visible"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base), {
            pointerEvents: "none"
        });
    },
    singleValue: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base), {
            pointerEvents: "none"
        });
    }
};
function getQuoteFormLocationNoOptionsMessage(inputValue, copy) {
    if (!inputValue) {
        return copy.enterLocation;
    }
    if ((0,_methods_location_search__WEBPACK_IMPORTED_MODULE_6__/* .isPlaceSearchQueryTooShort */ .ci)(inputValue)) {
        return copy.getMoreCharactersLabel((0,_methods_location_search__WEBPACK_IMPORTED_MODULE_6__/* .getPlaceSearchRemainingCharCount */ ._A)(inputValue));
    }
    return copy.noSuchLocation;
}
/** Must sit above BottomSheet (compact load posting route step on mobile). */ var QUOTE_FORM_LOCATION_MENU_Z_INDEX = _vahak_core_ui_dist_constants__WEBPACK_IMPORTED_MODULE_3__/* .zIndexList.bottomSheet */ .m7.bottomSheet + 1;
/** Portal menu to body when needed (Android); iOS keeps absolute so menu tracks keyboard scroll. */ function getQuoteFormLocationMenuConfig(portalMenu) {
    var nativeInputTapTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var attach = (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_4__/* .getSelectMenuAttachConfig */ .N_)(portalMenu);
    var isPortaled = attach.menuPosition === "fixed";
    var locationStyles = nativeInputTapTarget ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, QUOTE_FORM_LOCATION_MENU_STYLES, SHEET_NATIVE_INPUT_STYLES) : QUOTE_FORM_LOCATION_MENU_STYLES;
    var _zIndex;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, attach), {
        styles: isPortaled ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, locationStyles), {
            menuPortal: function(base) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base), {
                    zIndex: QUOTE_FORM_LOCATION_MENU_Z_INDEX
                });
            },
            menu: function(base) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, base), {
                    zIndex: (_zIndex = base.zIndex) !== null && _zIndex !== void 0 ? _zIndex : QUOTE_FORM_LOCATION_MENU_Z_INDEX
                });
            }
        }) : locationStyles
    });
}
var hiddenMultiValue = function() {
    return null;
};
function filterOptionByLabel(option, inputValue) {
    return option.label.toLowerCase().includes(inputValue.trim().toLowerCase());
}
function renderHighlightedText(text, query, highlightClassName) {
    if (!text || !(query === null || query === void 0 ? void 0 : query.trim())) {
        return text;
    }
    var escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var parts = text.split(new RegExp("(".concat(escapedQuery, ")"), "gi"));
    return parts.map(function(part, index) {
        if (part.toLowerCase() === query.toLowerCase()) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: highlightClassName,
                children: part
            }, "".concat(part, "-").concat(index));
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: part
        }, "".concat(part, "-").concat(index));
    });
}
function createQuoteFormLocationControl(Styles, icon, options) {
    return function(_param) {
        var children = _param.children, className = _param.className, innerProps = _param.innerProps, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
            "children",
            "className",
            "innerProps"
        ]);
        var _onMouseDown = innerProps.onMouseDown, _onTouchEnd = innerProps.onTouchEnd, restInnerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(innerProps, [
            "onMouseDown",
            "onTouchEnd"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.Control, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            innerProps: (options === null || options === void 0 ? void 0 : options.allowNativeTouchFocus) ? restInnerProps : innerProps,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "select-control", props.selectProps.isSearchable && "select-control--searchable", Styles.locationSelectControl),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: Styles.fieldIconWrap,
                    "aria-hidden": true,
                    children: icon
                }),
                children
            ]
        }));
    };
}
function createQuoteFormLorryControl(Styles, icon) {
    return function(_param) /*#__PURE__*/ {
        var children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
            "children",
            "className"
        ]);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.Control, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "select-control", Styles.locationSelectControl, Styles.lorrySelectControl, props.selectProps.menuIsOpen && Styles.lorrySelectControlOpen),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: Styles.fieldIconWrap,
                    "aria-hidden": true,
                    children: icon
                }),
                children
            ]
        }));
    };
}
function createQuoteFormChevronIndicator(Styles, icon) {
    return function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.DropdownIndicator, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            className: Styles.selectChevronWrap,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(Styles.chevronIcon, props.selectProps.menuIsOpen && Styles.chevronIconOpen),
                children: icon
            })
        }));
    };
}
function createQuoteFormLocationPlaceholder(Styles) {
    return function(_param) /*#__PURE__*/ {
        var children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
            "children",
            "className"
        ]);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.Placeholder, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "select-placeholder", Styles.fieldPlaceholder),
            children: children
        }));
    };
}
function createQuoteFormLocationSingleValue(Styles) {
    return function(_param) /*#__PURE__*/ {
        var children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
            "children",
            "className"
        ]);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.SingleValue, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "select-singleValue", Styles.fieldValue),
            children: children
        }));
    };
}
function createQuoteFormLocationInput(options) {
    return function(props) {
        var className = props.className, isHidden = props.isHidden, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
            "className",
            "isHidden"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.Input, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
            isHidden: (options === null || options === void 0 ? void 0 : options.alwaysVisible) ? false : isHidden,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "select-input")
        }));
    };
}
function createQuoteFormLocationMenu(Styles) {
    var requireInput = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return function(_param) {
        var className = _param.className, placement = _param.placement, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
            "className",
            "placement"
        ]);
        if (requireInput && !props.selectProps.inputValue) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.Menu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            placement: placement,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, Styles.locationDropdownMenu, placement === "top" && Styles.locationDropdownMenuTop)
        }));
    };
}
function createQuoteFormLocationOption(Styles) {
    return function(props) {
        var data = props.data, isFocused = props.isFocused, isSelected = props.isSelected, selectProps = props.selectProps;
        var inputValue = String(selectProps.inputValue || "");
        var descriptionLabel = (0,_placeLabels__WEBPACK_IMPORTED_MODULE_11__/* .getPlaceDescriptionLabel */ .$$)(data.value);
        var isActive = isFocused || isSelected;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.Option, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(Styles.locationOption, isActive && Styles.locationOptionActive),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_location_pin_outlined_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(Styles.locationOptionIcon, isActive && Styles.locationOptionIconActive),
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: Styles.locationOptionText,
                    children: renderHighlightedText(descriptionLabel, inputValue, Styles.locationMatch)
                })
            ]
        }));
    };
}
function createQuoteFormLocationSelectComponents(Styles, options) {
    return {
        DropdownIndicator: function() {
            return null;
        },
        Menu: createQuoteFormLocationMenu(Styles),
        NoOptionsMessage: createQuoteFormNoOptionsMessage(Styles, options.getNoOptionsMessage),
        Option: createQuoteFormLocationOption(Styles),
        Control: createQuoteFormLocationControl(Styles, options.icon, {
            allowNativeTouchFocus: options.revealNativeInput
        }),
        Input: createQuoteFormLocationInput({
            alwaysVisible: options.revealNativeInput
        }),
        Placeholder: createQuoteFormLocationPlaceholder(Styles),
        SingleValue: createQuoteFormLocationSingleValue(Styles)
    };
}
function createQuoteFormNoOptionsMessage(Styles, getMessage) {
    return function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.NoOptionsMessage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("select-noOptionMessage", Styles.locationNoOptionsMessage),
            children: getMessage(String(props.selectProps.inputValue || ""))
        }));
    };
}
function createQuoteFormMultiValueContainer(Styles, displayValue) {
    return function(props) {
        if (!displayValue) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.ValueContainer, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_select__WEBPACK_IMPORTED_MODULE_10__.c.ValueContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(Styles.fieldValue, Styles.multiFieldValue),
                    title: displayValue,
                    children: displayValue
                }),
                react__WEBPACK_IMPORTED_MODULE_1__.Children.map(props.children, function(child) {
                    if (!/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(child)) {
                        return child;
                    }
                    return child.type === react_select__WEBPACK_IMPORTED_MODULE_10__.c.MultiValue ? null : child;
                })
            ]
        }));
    };
}


/***/ }),

/***/ 51035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ mapPlaceSearchResponseIntoText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_ui_dist_components_Search_Search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92036);
/* harmony import */ var _auth_current_location_CurrentLocation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81720);
/* harmony import */ var _methods_location_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75002);
/* harmony import */ var _methods_uiUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34695);
/* harmony import */ var _vahak_core_ui_dist_methods_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21131);










var mapPlaceSearchResponseIntoText = function(place) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var lambda = function(l) {
        return (0,_vahak_core_ui_dist_methods_array__WEBPACK_IMPORTED_MODULE_6__/* .getJoinedStringFromArray */ .D$)((0,_vahak_core_ui_dist_methods_array__WEBPACK_IMPORTED_MODULE_6__/* .filteredArray */ .V3)([
            place === null || place === void 0 ? void 0 : place.city,
            place === null || place === void 0 ? void 0 : place.state,
            place === null || place === void 0 ? void 0 : place.country
        ], true).slice(0, l));
    };
    var fullText = (place === null || place === void 0 ? void 0 : place.description) || lambda(2);
    var limitedText = lambda(limit);
    return limit === 0 ? fullText : limitedText;
};
var UserCurrentLocation = function(param) {
    var _id = param.id, id = _id === void 0 ? "location" : _id, _name = param.name, name = _name === void 0 ? "location" : _name, _showUserCurrentLocation = param.showUserCurrentLocation, showUserCurrentLocation = _showUserCurrentLocation === void 0 ? false : _showUserCurrentLocation, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, onChange = param.onChange, value = param.value, valueText = param.valueText, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, dropdownProps = param.dropdownProps, source = param.locationSearchSource, tmp = param.showCompleteDesc, _showCompleteDesc = tmp === void 0 ? true : tmp, tag = param.tag, borderRadius = param.borderRadius;
    var showCompleteDesc = !!_showCompleteDesc && !!(value === null || value === void 0 ? void 0 : value.description);
    var globalData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).globalData;
    var userPlaceInfo = globalData === null || globalData === void 0 ? void 0 : globalData["userPlaceInfo"];
    var onClickGetCurrentLocation = function() {
        onChange === null || onChange === void 0 ? void 0 : onChange(userPlaceInfo, mapPlaceSearchResponseIntoText(userPlaceInfo), name);
    };
    var SeparatorIndicator = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_auth_current_location_CurrentLocation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            id: id + "-current",
            onClick: onClickGetCurrentLocation
        });
    };
    var optionGeneratedFromPlaceInfo = !!value ? (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_7__/* .generateSelectOption */ .Ow)(mapPlaceSearchResponseIntoText(value, showCompleteDesc ? 0 : undefined), value, value === null || value === void 0 ? void 0 : value.place_id) : undefined;
    var optionGeneratedFromText = !!valueText ? (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_7__/* .generateSelectOption */ .Ow)(valueText, valueText, valueText) : undefined;
    var currentSelectedOption = optionGeneratedFromPlaceInfo !== null && optionGeneratedFromPlaceInfo !== void 0 ? optionGeneratedFromPlaceInfo : optionGeneratedFromText;
    var handleChange = function(value) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value === null || value === void 0 ? void 0 : value.value, mapPlaceSearchResponseIntoText(value === null || value === void 0 ? void 0 : value.value, showCompleteDesc ? 0 : undefined), name);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Search_Search__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            name: name,
            onChange: handleChange,
            option: [],
            loadOptions: function(str, cb) {
                return (0,_methods_location_search__WEBPACK_IMPORTED_MODULE_5__/* .generateCityLoadOption */ .EF)(str, cb, {
                    source: source,
                    tag: tag
                });
            },
            customDropDownIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            value: currentSelectedOption,
            placeholder: placeholder
        }, showUserCurrentLocation && !!userPlaceInfo && !(value || valueText) && {
            customSeparatorIndicator: SeparatorIndicator
        }), {
            id: id,
            isClearable: true,
            noOptionHandler: function(o) {
                return o.inputValue ? "No such location" : "Enter a location";
            },
            autoFocus: autoFocus,
            openMenuOnClick: false
        }), dropdownProps), {
            borderRadius: borderRadius
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserCurrentLocation);


/***/ }),

/***/ 75002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E7": function() { return /* binding */ ActionCategoryBasedLocationTags; },
/* harmony export */   "EF": function() { return /* binding */ generateCityLoadOption; },
/* harmony export */   "_A": function() { return /* binding */ getPlaceSearchRemainingCharCount; },
/* harmony export */   "ci": function() { return /* binding */ isPlaceSearchQueryTooShort; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20803);
/* harmony import */ var _uiUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34695);





var ActionCategoryBasedLocation;
(function(ActionCategoryBasedLocation) {
    ActionCategoryBasedLocation["SEARCH"] = "SEARCH";
    ActionCategoryBasedLocation["POSTING"] = "POSTING";
    ActionCategoryBasedLocation["COMPANY_UPDATE"] = "COMPANY_UPDATE";
})(ActionCategoryBasedLocation || (ActionCategoryBasedLocation = {}));
var _obj;
var ActionCategoryBasedLocationTags = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, ActionCategoryBasedLocation.SEARCH, undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, ActionCategoryBasedLocation.POSTING, [
    "point_locations"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, ActionCategoryBasedLocation.COMPANY_UPDATE, [
    "point_locations"
]), _obj);
var generateCityLoadOption = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(str, callback, option) {
        var results, _description, _$option;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(str && str.length >= _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_1__/* .PLACE_SEARCH_QUERY_LENGTH */ .$Z)) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 3;
                    return (0,_vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_1__/* .searchUsingPlacesAPI */ .PP)(str, option);
                case 3:
                    results = _ctx.sent;
                    if (!(results && results.length)) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    _$option = results === null || results === void 0 ? void 0 : results.map(function(res) {
                        return (0,_uiUtil__WEBPACK_IMPORTED_MODULE_4__/* .generateSelectOption */ .Ow)((_description = res.description) !== null && _description !== void 0 ? _description : "", res, res.place_id);
                    });
                    callback(_$option);
                    return _ctx.abrupt("return");
                case 9:
                    callback([]);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function generateCityLoadOption(str, callback, option) {
        return _ref.apply(this, arguments);
    };
}();
function getPlaceSearchRemainingCharCount(query) {
    if (!query) {
        return _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_1__/* .PLACE_SEARCH_QUERY_LENGTH */ .$Z;
    }
    return Math.max(0, _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_1__/* .PLACE_SEARCH_QUERY_LENGTH */ .$Z - query.length);
}
function isPlaceSearchQueryTooShort(query) {
    return query.length < _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_1__/* .PLACE_SEARCH_QUERY_LENGTH */ .$Z;
}


/***/ }),

/***/ 87163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"CurrentLocation_main__PP4_M","text":"CurrentLocation_text__28M4R"};

/***/ }),

/***/ 62095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationDropdownMenu":"QuoteFormFields_locationDropdownMenu__9BmUd","locationDropdownMenuTop":"QuoteFormFields_locationDropdownMenuTop__LGiYK","locationNoOptionsMessage":"QuoteFormFields_locationNoOptionsMessage__Cq5xU","locationOption":"QuoteFormFields_locationOption__rIy1z","locationOptionActive":"QuoteFormFields_locationOptionActive__H6H_9","locationOptionText":"QuoteFormFields_locationOptionText__DcxY2","locationMatch":"QuoteFormFields_locationMatch__fPnCG","locationOptionIcon":"QuoteFormFields_locationOptionIcon__BEnqi","locationOptionIconActive":"QuoteFormFields_locationOptionIconActive__L_xu_","root":"QuoteFormFields_root__eJ4Ks","fieldWrap":"QuoteFormFields_fieldWrap__AeHeY","fieldWrapSelect":"QuoteFormFields_fieldWrapSelect__0EgO_","fieldWrapMulti":"QuoteFormFields_fieldWrapMulti__u2UCJ","multiFieldValue":"QuoteFormFields_multiFieldValue__jWRbm","fieldWrapSearchable":"QuoteFormFields_fieldWrapSearchable__Muu40","locationSelectControl":"QuoteFormFields_locationSelectControl__x2XPh","fieldIconWrap":"QuoteFormFields_fieldIconWrap__V3cAY","fieldPlaceholder":"QuoteFormFields_fieldPlaceholder__I6dq5","fieldValue":"QuoteFormFields_fieldValue__4ns9M","selectChevronWrap":"QuoteFormFields_selectChevronWrap__AuNS_","fieldIcon":"QuoteFormFields_fieldIcon__3267J","fieldIconPin":"QuoteFormFields_fieldIconPin__I3IgA","chevronIcon":"QuoteFormFields_chevronIcon__AAcVw","chevronIconOpen":"QuoteFormFields_chevronIconOpen__RDBit","lorrySelectControl":"QuoteFormFields_lorrySelectControl__iD6PR","lorrySelectControlOpen":"QuoteFormFields_lorrySelectControlOpen__TuWMf","checkboxOptionRow":"QuoteFormFields_checkboxOptionRow__3CrtF","lorryDropdownMenu":"QuoteFormFields_lorryDropdownMenu__X5Bco","lorryOption":"QuoteFormFields_lorryOption__rHBuy","lorryOptionActive":"QuoteFormFields_lorryOptionActive__TEfbB","lorryOptionSelected":"QuoteFormFields_lorryOptionSelected__vl39F","heroRoute":"QuoteFormFields_heroRoute__Bd2eN","heroRail":"QuoteFormFields_heroRail__lYG6q","heroRailDot":"QuoteFormFields_heroRailDot__CFlyg","heroRailLine":"QuoteFormFields_heroRailLine__bxTfz","heroRailSquare":"QuoteFormFields_heroRailSquare__nOhCM","heroFields":"QuoteFormFields_heroFields__IpxFR","heroLabel":"QuoteFormFields_heroLabel__EJ_FK","heroField":"QuoteFormFields_heroField__R2Xhj","field":"QuoteFormFields_field__6xTu_","fieldInput":"QuoteFormFields_fieldInput__DmHP_","fieldError":"QuoteFormFields_fieldError__FOz1j","fieldInvalid":"QuoteFormFields_fieldInvalid__V3Yog","fieldDisabled":"QuoteFormFields_fieldDisabled__9_de9","hpv2HeroSlideIn":"QuoteFormFields_hpv2HeroSlideIn__AZE71","hpv2HeroFadeIn":"QuoteFormFields_hpv2HeroFadeIn__dNC13","hpv2HeroFadeInOpacity":"QuoteFormFields_hpv2HeroFadeInOpacity__0ot0G","hpv2FadeUp":"QuoteFormFields_hpv2FadeUp__DVj4R","hpv2FadeLeft":"QuoteFormFields_hpv2FadeLeft__K2W6C","hpv2FadeRight":"QuoteFormFields_hpv2FadeRight__1NwGQ","hpv2ScaleUp":"QuoteFormFields_hpv2ScaleUp__rEZG6","hpv2Blink":"QuoteFormFields_hpv2Blink__3RXTk","hpv2FloatA":"QuoteFormFields_hpv2FloatA__9YKCo","hpv2FloatB":"QuoteFormFields_hpv2FloatB__SHqEY","hpv2DemoProgress":"QuoteFormFields_hpv2DemoProgress__m76dL","hpv2DemoSlideIn":"QuoteFormFields_hpv2DemoSlideIn__6wV0y","hpv2DemoFadeIn":"QuoteFormFields_hpv2DemoFadeIn__WZCpD","hpv2DemoScaleIn":"QuoteFormFields_hpv2DemoScaleIn__WIZ95","hpv2DemoBounce":"QuoteFormFields_hpv2DemoBounce__YNJHq","hpv2PulseDot":"QuoteFormFields_hpv2PulseDot__ZmsiX","hpv2PriceShimmer":"QuoteFormFields_hpv2PriceShimmer__C1eFh"};

/***/ })

}]);